import { Link } from 'react-router-dom';
import { ResetPasswordForm } from '@/components/forms/ResetPasswordForm';
import { Card } from 'antd';

/**
 * 忘记密码页面
 */
export const ForgotPassword = () => {
  const currentYear = new Date().getFullYear();
  const foundedYear = 2026;  // 公司成立年份
  
  // 自动生成：2026 → "2026"；2027 → "2026-2027"
  const copyrightYear = currentYear === foundedYear 
    ? foundedYear 
    : `${foundedYear}-${currentYear}`;

  return (
    <div className="flex flex-col min-h-screen bg-gray-50 relative">
      {/* 左上角 Logo + 文字 */}
      <div className="fixed top-6 left-6 z-10 flex items-center gap-2">
        <img 
          src="/favicon.png" 
          alt="平台 Logo" 
          className="w-16 h-16 object-contain"
          onError={(e) => {
            console.warn('Logo 加载失败，使用备用图标。');
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
        <span className="text-xl font-bold text-gray-800">轻智云创开发者平台</span>
      </div>

      {/* 主体区域 */}
      <div className="flex-1 flex flex-col justify-center py-16 px-4 sm:px-6 lg:px-8 w-full max-w-md mx-auto">
        <div className="text-center mb-10">
          {/* <div className="inline-flex items-center justify-center w-16 h-16 bg-linear-to-r from-blue-500 to-purple-600 rounded-full mb-6">
            <LockOutlined className="text-white text-2xl" />
          </div> */}
          <h2 className="text-2xl font-bold text-gray-800 mb-3">忘记密码</h2>
          {/* <p className="text-gray-600 max-w-xs mx-auto">
            通过邮箱验证码重置您的登录密码
          </p> */}
        </div>

        <Card 
          className="shadow-lg border-0 rounded-xl"
          styles={{ body: { padding: '32px' } }}
        >
          <ResetPasswordForm />
          
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-600">
              记得密码了？{' '}
              <Link 
                to="/login" 
                className="font-medium text-blue-600 hover:text-blue-500 transition-colors"
              >
                立即登录
              </Link>
            </p>
          </div>
        </Card>
      </div>

      {/* 页脚 */}
      <div className="text-center p-4 bg-white text-sm text-gray-500 border-t border-gray-100">
        ©{copyrightYear} 深圳轻智云创新物联科技有限公司 版权所有
        <span className="mx-3">|</span>
        <a 
          href="https://beian.miit.gov.cn/#/Integrated/index" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-gray-500 hover:text-blue-600 no-underline transition-colors"
        >
          粤ICP备2026011563号-2
        </a>
      </div>
    </div>
  );
};